import BudgetModes from '@/common/enums/budget-modes.enum';
import { IAdvertiserAPI } from '@/common/models/advertisers/Advertiser';
import CachedPacing, { ICachedPacingAPI } from '@/common/models/CachedPacing';
import OrganizationType from '@/common/models/memberships/OrganizationType.enum';
import { IAccountAPI } from '@/common/models/misc-api-models/Account';

import Campaign, { ICampaignAPI } from './Campaign';

interface ISharedCampaignCredentials {
  password: string;
}

export interface IOrganizationSharedCampaign {
  type: 'supply' | 'demand';
  currency: string;
  currency_symbol: string;
  timezone: string;
}

interface ISharedCampaignDataApi extends ICampaignAPI {
  name: string;
  campaign_id: number;
  account: IAccountAPI;
  advertiser: IAdvertiserAPI;
  modified_on_utc: string;
  created_by: number;
  organization_id: number;
  start_date: string;
  end_date: string;
  plan_id: number;
  budget: number;
  pacing_budget: number;
  pacing_budget_mode: BudgetModes;
  plan?: {
    plan_id: number;
    uuid: string;
  };
  cachedpacing?: ICachedPacingAPI;
  organization_type: OrganizationType.SUPPLY | OrganizationType.DEMAND;
  organization: IOrganizationSharedCampaign;
}

class SharedCampaign {
  private constructor(public password: string) {}

  static fromObject(credentials: ISharedCampaignCredentials) {
    return new SharedCampaign(credentials.password);
  }

  public toApi(): ISharedCampaignCredentials {
    return {
      password: this.password,
    };
  }

  static fromApi(apiObject: ISharedCampaignDataApi) {
    const campaign = Campaign.fromApi(apiObject);
    campaign.plan = apiObject.plan;
    campaign.cachedPacing = apiObject.cachedpacing != null ? CachedPacing.fromApi(apiObject.cachedpacing) : null;
    campaign.organizationType = apiObject.organization_type;
    campaign.organization = apiObject.organization;
    return campaign;
  }
}

export default SharedCampaign;
